var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-824.000000, -1639.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Security",
    transform: "translate(824.000000, 1639.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0526976,0 L30,6.947 L30,14.692 C30,20.446 26.8993726,25.757 21.8785445,28.601 L21.8785445,28.601 L15.8770389,32 L10.0160602,28.621 C5.05545797,25.761 2,20.483 2,14.772 L2,14.772 L2,6.947 L16.0526976,0 Z M16,11 C14.372,11 13.052,12.32 13.052,13.949 C13.052,15.005 13.609,15.931 14.444,16.452 L14.444,16.452 L14.444,19.444 C14.444,20.304 15.141,21 16,21 C16.86,21 17.557,20.304 17.557,19.444 L17.557,19.444 L17.557,16.452 C18.392,15.931 18.949,15.005 18.949,13.949 C18.949,12.32 17.628,11 16,11 Z",
    id: 152
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionSecurity);
export default __webpack_public_path__ + "static/media/navigation-and-action-security.4448fc55.svg";
export { ForwardRef as ReactComponent };